import React from "react";
import { Route, Switch } from "react-router-dom";

import Home from "../components/Home";
import Enviroment from "../components/Enviroment";
import Data from "../components/Data";
import Model from "../components/Model";
import Strategy from "../components/Strategy";
import Transformations from "../components/Transformations";
import FinalTests from "../components/FinalTests";

const publicPath = "/";

export const routeCodes = {
  HOME: publicPath,
  LOGIN: `${publicPath}login`,
  ENVIROMENT: `${publicPath}enviroment`,
  DATA: `${publicPath}data`,
  MODEL: `${publicPath}model`,
  STRATEGY: `${publicPath}strategy`,
  TRANSFORMATIONS: `${publicPath}transformations`,
  FINALTESTS: `${publicPath}finaltests`,
};

export default props => {
  return (
    <Switch>
      <Route path={`${publicPath}enviroment`} component={Enviroment} />
      <Route path={`${publicPath}data`} component={Data} />
      <Route path={`${publicPath}model`} component={Model} />
      <Route path={`${publicPath}strategy`} component={Strategy} />
      <Route path={`${publicPath}transformations`} component={Transformations} />
      <Route path={`${publicPath}finaltests`} component={FinalTests} />
      <Route exact path={publicPath} component={Home} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./src/config/routes.js